import React from 'react';
import Svg, {Circle, Ellipse, Path, Polygon, Polyline, Rect} from 'react-native-svg';

// Construct only fixed primitives from validated numeric geometry. Never parse
// model-authored SVG/XML, path strings, styles, URLs or event handlers.
export default function DiagramDrawing({shapes, tones, fills}) {
  return <Svg width="100%" height="100%" viewBox="0 0 1000 600" style={{position:'absolute',left:0,top:0}}>
    {shapes.map((shape,index)=>{
      const tone=shape.tone||'ink';
      const props={stroke:tones[tone],strokeWidth:shape.strokeWidth||3,
        fill:shape.filled?fills[tone]:'none',strokeLinecap:'round',strokeLinejoin:'round'};
      if(shape.type==='line') return <Polyline key={index} {...props} points={shape.points.map(point=>point.join(',')).join(' ')} />;
      if(shape.type==='polygon') return <Polygon key={index} {...props} points={shape.points.map(point=>point.join(',')).join(' ')} />;
      if(shape.type==='curve') {
        const [start,c1,c2,end]=shape.points;
        return <Path key={index} {...props} d={`M ${start.join(' ')} C ${c1.join(' ')} ${c2.join(' ')} ${end.join(' ')}`} />;
      }
      if(shape.type==='circle') return <Circle key={index} {...props} cx={shape.cx} cy={shape.cy} r={shape.r} />;
      if(shape.type==='ellipse') return <Ellipse key={index} {...props} cx={shape.cx} cy={shape.cy} rx={shape.rx} ry={shape.ry} />;
      return <Rect key={index} {...props} x={shape.x} y={shape.y} width={shape.width} height={shape.height} rx={3} />;
    })}
  </Svg>;
}
